export enum ServiceStatus {
    Unseated,
    Drinks,
    Starter,
    Main,
    Dessert,
    Bill,
    Cleaning,
    Paid,
    Closed,
}

export const SERVICE_STATUSES: ServiceStatus[] = [
    ServiceStatus.Unseated,
    ServiceStatus.Drinks,
    ServiceStatus.Starter,
    ServiceStatus.Main,
    ServiceStatus.Dessert,
    ServiceStatus.Bill,
    ServiceStatus.Cleaning,
    ServiceStatus.Paid,
    ServiceStatus.Closed,
]

export const SELECTABLE_SERVICE_STATUSES: ServiceStatus[] = [
    ServiceStatus.Drinks,
    ServiceStatus.Starter,
    ServiceStatus.Main,
    ServiceStatus.Dessert,
    ServiceStatus.Bill,
    ServiceStatus.Cleaning,
    ServiceStatus.Paid,
]

export const SERVICE_STATUS_LABELS: Record<ServiceStatus, string> = {
    [ServiceStatus.Unseated]: 'Unseated',
    [ServiceStatus.Drinks]: 'Drinks',
    [ServiceStatus.Starter]: 'Starter',
    [ServiceStatus.Main]: 'Main',
    [ServiceStatus.Dessert]: 'Dessert',
    [ServiceStatus.Bill]: 'Bill',
    [ServiceStatus.Cleaning]: 'Cleaning',
    [ServiceStatus.Paid]: 'Paid',
    [ServiceStatus.Closed]: 'Closed',
}

export const SERVICE_STATUS_CLASS_NAMES: Record<ServiceStatus, string> = {
    [ServiceStatus.Unseated]: 'unseated',
    [ServiceStatus.Drinks]: 'drinks',
    [ServiceStatus.Starter]: 'starter',
    [ServiceStatus.Main]: 'main',
    [ServiceStatus.Dessert]: 'dessert',
    [ServiceStatus.Bill]: 'bill',
    [ServiceStatus.Cleaning]: 'cleaning',
    [ServiceStatus.Paid]: 'paid',
    [ServiceStatus.Closed]: 'closed',
}

export function isSelectableServiceStatus(serviceStatus: ServiceStatus | null | undefined): serviceStatus is ServiceStatus {
    return serviceStatus !== null
        && serviceStatus !== undefined
        && SELECTABLE_SERVICE_STATUSES.includes(serviceStatus)
}
